/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "0ce7a379a68817f606650f0cf71a2263bcafc50f";
